window.i18n_fr = {
  "general": {
    "accessibility": {
      "skip_to_content": "Passer au contenu",
      "close_modal": "Fermer",
      "link_messages": {
        "new_window": "S'ouvre dans une nouvelle fenêtre.",
        "external": "Ouvre un site externe.",
        "new_window_and_external": "Ouvre un site externe dans une nouvelle fenêtre."
      },
      "refresh_page": "Le choix d'une sélection entraîne l'actualisation d'une page entière.",
      "selection_help": "Appuyez sur la touche espace puis sur les touches fléchées pour faire une sélection.",
      "unit_price_separator": "par",
      "error": "Erreur"
    },
    "meta": {
      "tags": "Balises \"{{ tags }}\"",
      "page": "Page {{ page }}"
    },
    "404": {
      "title": "404 - Page non trouvée",
      "subtext": "Cette page n'est pas disponible.",
      "link": "Poursuivre vos achats"
    },
    "pagination": {
      "previous": "Page précédente",
      "next": "Page suivante",
      "current_page": "Page {{ current }} sur {{ total }}"
    },
    "password_page": {
      "opening_soon": "Ouverture prochaine",
      "login_form_heading": "Accéder à la boutique avec un mot de passe",
      "login_form_password_label": "Mot de passe",
      "login_form_password_placeholder": "Votre mot de passe",
      "login_form_submit": "Entrer",
      "signup_form_email_label": "E-mail",
      "signup_form_success": "Nous vous enverrons un e-mail juste avant l'ouverture !",
      "admin_link_html": "Vous êtes le propriétaire de la boutique ? <a href=\"/admin\" class=\"text-link\">Connectez-vous ici</a>.",
      "password_link": "Entrer avec un mot de passe"
    },
    "social": {
      "share_on_facebook": "Partager",
      "share_on_twitter": "Tweeter",
      "share_on_pinterest": "Épingler",
      "alt_text": {
        "share_on_facebook": "Partager sur Facebook",
        "share_on_twitter": "Tweeter sur Twitter",
        "share_on_pinterest": "Épingler sur Pinterest"
      }
    },
    "search": {
      "empty_search_message": "Le champ de recherche ne peut pas être vide",
      "title": "Effectuer une recherche",
      "placeholder": "Rechercher",
      "submit": "Soumettre",
      "close": "Fermer",
      "heading": {
        "one": "Résultat de la recherche",
        "other": "Résultats de la recherche"
      },
      "search_for": "Rechercher",
      "loading": "Chargement",
      "clear_search_term": "Effacer le terme de recherche",
      "number_of_results": "{{ result_number }} sur {{ results_count }}",
      "products": "Produits",
      "number_of_results_found": "{{ results_count }} résultats trouvés",
      "one_result_found": "1 résultat trouvé",
      "no_results": "Essayez de vérifier votre orthographe ou d'utiliser des mots différents.",
      "results_with_count": {
        "one": "{{ count }} résultat pour « {{ terms }} »",
        "other": "{{ count }} résultats pour « {{ terms }} »"
      }
    },
    "newsletter_form": {
      "newsletter_email": "Inscrivez-vous à notre newsletter",
      "email_placeholder": "Adresse e-mail",
      "confirmation": "Merci de vous être abonné(e) !",
      "submit": "S'inscrire"
    },
    "filters": {
      "show_more": "Afficher plus",
      "show_less": "Afficher moins"
    },
    "payment": {
      "method": "Moyens de paiement"
    },
    "currency": {
      "dropdown_label": "Devise"
    },
    "language": {
      "dropdown_label": "Langue"
    }
  },
  "sections": {
    "slideshow": {
      "next_slide": "Diapositive suivante",
      "previous_slide": "Diapositive précédente",
      "pause_slideshow": "Mettre le diaporama en pause",
      "rotate_slideshow": "Lire le diaporama",
      "load_slide": "Charger la diapositive {{ slide_number }}",
      "navigation_instructions": "Utilisez les flèches gauche/droite pour naviguer dans le diaporama ou glissez vers la gauche/droite sur un appareil mobile"
    },
    "featured_product": {
      "title": "Produit en vedette",
      "gallery_thumbnail_alt": "Charger l'image dans la galerie, {{ imageAlt }}",
      "video_thumbnail_alt": "Charger et lire la vidéo dans la visionneuse de la Galerie, {{ imageAlt }}",
      "model_thumbnail_alt": "Charger le modèle 3D dans la Galerie, {{ imageAlt }}"
    },
    "map": {
      "address_error": "Une erreur s'est produite dans la recherche de cette adresse",
      "address_no_results": "Aucun résultat pour cette adresse",
      "address_query_limit_html": "Vous avez dépassé la limite d'utilisation de l'API de Google. Pensez à mettre à niveau vers un <a href=\"https://developers.google.com/maps/premium/usage-limits\">forfait premium</a>.",
      "auth_error_html": "Une erreur s'est produite lors de l'authentification de votre compte Google Maps.",
      "section_heading": "Emplacement"
    },
    "video": {
      "play": "Lire la vidéo {{ video_title }}",
      "pause": "Suspendre la vidéo {{ video_title }}",
      "resume": "Reprendre la vidéo {{ video_title }}",
      "close": "Fermer la vidéo {{ video_title }}"
    },
    "header": {
      "announcement_bar_label": "Annonce"
    }
  },
  "blogs": {
    "article": {
      "view_all": "Tous",
      "view_all_blogs": "Afficher tous les articles",
      "all_topics": "Tous les sujets",
      "by_author": "par {{ author }}",
      "posted_in": "Publié dans",
      "read_more": "En savoir plus",
      "read_more_title": "En savoir plus sur : {{ title }}",
      "back_to_blog": "Retour à {{ title }}",
      "tags": "Balises",
      "article_with_count": {
        "one": "{{ count }} article",
        "other": "{{ count }} articles"
      }
    },
    "comments": {
      "title": "Laisser un commentaire",
      "name": "Nom",
      "email": "E-mail",
      "message": "Message",
      "post": "Publier le commentaire",
      "moderated": "Veuillez noter que les commentaires doivent être approuvés avant d'être publiés",
      "success_moderated": "Votre commentaire a bien été soumis. Notre blog étant modéré, il sera publié sous peu.",
      "success": "Votre commentaire bien été publié !",
      "unapproved": "L'adresse e-mail fournie n'est pas approuvée pour la publication de commentaires.",
      "comments_with_count": {
        "one": "{{ count }} commentaire",
        "other": "{{ count }} commentaires"
      }
    }
  },
  "cart": {
    "general": {
      "title": "Votre panier",
      "note": "Ajouter une note à votre commande",
      "removed_item_html": "<span class=\"cart__removed-product-details\">({{ quantity }}) {{ link }}</span> supprimé(s) de votre panier.",
      "remove": "Supprimer",
      "subtotal": "Sous-total",
      "savings": "Vous économisez",
      "taxes_and_shipping_at_checkout": "Taxes et frais de port calculés à l'étape de paiement",
      "taxes_and_shipping_policy_at_checkout_html": "Taxes et <a href=\"{{ link }}\">frais de port</a> calculés à l'étape de paiement",
      "taxes_included_but_shipping_at_checkout": "Taxes incluses et frais de port calculés à l'étape de paiement",
      "taxes_included_and_shipping_policy_html": "Taxes incluses. <a href=\"{{ link }}\">Frais de port</a> calculés à l'étape de paiement.",
      "update": "Mettre à jour",
      "checkout": "Passer à la caisse",
      "empty": "Votre panier est vide.",
      "cookies_required": "Activer les cookies pour pouvoir utiliser le panier",
      "continue_shopping": "Poursuivre vos achats",
      "cart_error": "Une erreur est survenue lors de l’actualisation de votre panier. Essayez de nouveau s’il vous plaît."
    },
    "label": {
      "discounted_total": "Total après réduction",
      "product": "Produit",
      "price": "Prix",
      "price_column": "Voir les détails de la réduction dans la colonne Prix.",
      "product_details": "Détails des produits",
      "quantity": "Quantité",
      "qty": "Qté",
      "regular_total": "Total avant réduction",
      "remove": "Supprimer {{ product }}",
      "total": "Total",
      "update": "Mettre à jour"
    },
    "popup": {
      "added_to_cart": "Ajouté au panier à l'instant",
      "cart_count": {
        "one": "{{ count }} article",
        "other": "{{ count }} articles"
      },
      "product_details": "Détails des produits",
      "quantity": "Qté",
      "quantity_label": "Quantité : {{ quantity_count }}"
    }
  },
  "collections": {
    "general": {
      "view_all": "Tous",
      "view_all_label": "Afficher tous les produits de la collection {{ collection_name }}",
      "no_matches": "Cette collection ne comporte aucun produit",
      "items_with_count": {
        "one": "{{ count }} produit",
        "other": "{{ count }} produits"
      },
      "collection_label": "Collection"
    },
    "catalog": {
      "title": "Catalogue"
    },
    "sorting": {
      "title": "Trier par"
    },
    "filters": {
      "title_tags": "Filtrer par",
      "all_tags": "Tous les produits"
    }
  },
  "contact": {
    "form": {
      "name": "Nom",
      "email": "E-mail",
      "phone": "Numéro de téléphone",
      "message": "Message",
      "submit": "Envoyer",
      "post_success": "Merci pour votre message. Nous vous répondrons dès que possible.",
      "error_heading": "Merci de bien vouloir ajuster les éléments suivants :"
    }
  },
  "customer": {
    "account": {
      "title": "Mon compte",
      "details": "Détails du compte",
      "view_addresses": "Voir les adresses",
      "return": "Retour aux détails du compte"
    },
    "activate_account": {
      "title": "Activer le compte",
      "subtext": "Créez votre mot de passe pour activer votre compte.",
      "password": "Mot de passe",
      "password_confirm": "Confirmer le mot de passe",
      "submit": "Activer le compte",
      "cancel": "Refuser l'invitation"
    },
    "addresses": {
      "title": "Votre adresse",
      "default": "Par défaut",
      "add_new": "Ajouter une nouvelle adresse",
      "edit_address": "Modifier l'adresse",
      "first_name": "Prénom",
      "last_name": "Nom de famille",
      "company": "Entreprise",
      "address1": "Adresse",
      "address2": "Appt, suite, etc.",
      "city": "Ville",
      "country": "Pays/région",
      "province": "Province",
      "zip": "Code postal",
      "phone": "Téléphone",
      "set_default": "Définir comme adresse par défaut",
      "add": "Ajouter l'adresse",
      "update": "Mettre à jour l'adresse",
      "cancel": "Annuler",
      "edit": "Modifier",
      "delete": "Supprimer",
      "delete_confirm": "Souhaitez-vous vraiment supprimer cette adresse ?"
    },
    "login": {
      "title": "Connexion",
      "email": "E-mail",
      "password": "Mot de passe",
      "forgot_password": "Mot de passe oublié ?",
      "sign_in": "Se connecter",
      "guest_title": "Continuer en tant qu'invité(e)",
      "guest_continue": "Continuer"
    },
    "orders": {
      "title": "Historique des commandes",
      "order_number": "Commande",
      "order_number_link": "Numéro de commande {{ number }}",
      "date": "Date",
      "payment_status": "Statut du paiement",
      "fulfillment_status": "Statut du traitement",
      "total": "Total",
      "none": "Vous n'avez placé aucune commande."
    },
    "order": {
      "title": "Commande {{ name }}",
      "date_html": "Placée le {{ date }}",
      "cancelled_html": "Commande annulée le {{ date }}",
      "cancelled_reason": "Motif : {{ reason }}",
      "billing_address": "Adresse de facturation",
      "payment_status": "Statut du paiement",
      "shipping_address": "Adresse de livraison",
      "fulfillment_status": "Statut du traitement",
      "discount": "Réduction",
      "shipping": "Expédition",
      "tax": "Taxes",
      "product": "Produit",
      "sku": "SKU",
      "price": "Prix",
      "quantity": "Quantité",
      "total": "Total",
      "fulfilled_at_html": "Traitée le {{ date }}",
      "subtotal": "Sous-total",
      "track_shipment": "Suivre l'envoi"
    },
    "recover_password": {
      "title": "Réinitialiser votre mot de passe",
      "email": "E-mail",
      "submit": "Soumettre",
      "cancel": "Annuler",
      "subtext": "Nous vous enverrons un e-mail pour réinitialiser votre mot de passe.",
      "success": "Nous vous avons envoyé un e-mail avec un lien pour réinitialiser votre mot de passe."
    },
    "reset_password": {
      "title": "Réinitialiser le mot de passe du compte",
      "subtext": "Entrer un nouveau mot de passe pour {{ email }}",
      "password": "Mot de passe",
      "password_confirm": "Confirmer le mot de passe",
      "submit": "Réinitialiser le mot de passe"
    },
    "register": {
      "title": "Créer un compte",
      "first_name": "Prénom",
      "last_name": "Nom de famille",
      "email": "Adresse e-mail",
      "password": "Mot de passe",
      "submit": "Créer"
    }
  },
  "homepage": {
    "general": {
      "title": "Page d’accueil"
    },
    "onboarding": {
      "product_title": "Le nom de votre produit",
      "product_description": "Ce champ est utilisé pour décrire les détails de votre produit. Décrivez l'apparence, la présentation et le style de votre produit à vos clients. Ajoutez des détails sur la couleur, les matériaux utilisés, la taille et la provenance.",
      "collection_title": "Le nom de votre collection",
      "blog_title": "Le titre de votre article",
      "blog_excerpt": "Votre boutique n'a pas encore publié d'articles de blog. Vous pouvez utiliser votre blog pour annoncer le lancement d'un nouveau produit, partager des astuces ou des nouvelles avec vos clients. Consultez le blog e-commerce de Shopify pour puiser de l'inspiration et des conseils pour votre boutique et votre blog.",
      "blog_author": "Nom de l'auteur(e)",
      "no_content": "Il n'y a aucun contenu dans cette section pour l'instant. Ajoutez du contenu à cette section en utilisant la barra latérale."
    }
  },
  "layout": {
    "navigation": {
      "search": "Rechercher",
      "expand": "agrandir",
      "collapse": "réduire",
      "menu": "Menu"
    },
    "cart": {
      "title": "Panier",
      "items_count": {
        "one": "article",
        "other": "articles"
      }
    },
    "customer": {
      "account": "Compte",
      "log_out": "Se déconnecter",
      "log_in": "Se connecter",
      "create_account": "Créer un compte"
    },
    "footer": {
      "social_platform": "{{ name }} sur {{ platform }}"
    }
  },
  "products": {
    "product": {
      "regular_price": "Prix normal",
      "sold_out": "Épuisé",
      "unavailable": "Non disponible",
      "on_sale": "Solde",
      "sale_price": "Prix réduit",
      "quantity": "Quantité",
      "add_to_cart": "Ajouter au panier",
      "loader_label": "Ajout d'un produit à votre panier",
      "back_to_collection": "Retour à {{ title }}",
      "vendor": "Distributeur",
      "quantity_minimum_message": "La quantité doit être supérieure ou égale à 1",
      "include_taxes": "Taxes incluses.",
      "shipping_policy_html": "<a href=\"{{ link }}\">Frais d'expédition</a> calculés lors du paiement.",
      "unit_price_label": "Prix unitaire",
      "view_cart": "Voir le panier",
      "availability": "Disponibilité",
      "from_lowest_price_html": "de {{ lowest_price }}",
      "view_in_space": "Afficher dans votre espace",
      "view_in_space_label": "Affichage dans votre espace, charge l'article dans une fenêtre de réalité augmentée"
    }
  },
  "gift_cards": {
    "issued": {
      "title_html": "Voici votre carte-cadeau {{ shop }} d'une valeur de {{ value }} !",
      "subtext": "Votre carte-cadeau",
      "gift_card_code": "Code de la carte-cadeau",
      "disabled": "Désactivée",
      "expired": "A expiré le {{ expiry }}",
      "active": "Expire le {{ expiry }}",
      "redeem_html": "Veuillez saisir ce code lors du paiement pour utiliser votre carte-cadeau de {{ value }}",
      "shop_link": "Commencer vos achats",
      "print": "Imprimer cette carte-cadeau",
      "remaining_html": "{{ balance }} restants",
      "add_to_apple_wallet": "Ajouter à Apple Wallet",
      "qr_image_alt": "code QR - scannez pour réclamer votre carte-cadeau"
    }
  },
  "store_availability": {
    "general": {
      "view_store_info": "Afficher les informations de la boutique",
      "check_other_stores": "Vérifier la disponibilité dans d'autres boutiques",
      "pick_up_available": "Ramassage disponible",
      "pick_up_currently_unavailable": "Ramassage actuellement indisponible",
      "pick_up_available_at_html": "Ramassage disponible à <strong>{{ location_name }}</strong>",
      "pick_up_unavailable_at_html": "Ramassage actuellement indisponible à <strong>{{ location_name }}</strong>"
    }
  },
  "dynosim": {
    "auto": {
      "multiple_sessions_detected": "Sessions multiples détectées",
      "your_account_is_active_in_another_window": "Votre compte est actif dans une autre fenêtre ou un autre appareil. Fermez l'autre session pour continuer à utiliser AlphaX Tuning Sim.",
      "alphax_tuning_simulator": "Simulateur de Tuning AlphaX",
      "garage_tuning": "Garage (Tuning)",
      "dynamometer": "Dynamomètre",
      "drag_strip": "Piste d'accélération",
      "leaderboards": "Classements",
      "login": "connexion",
      "import_tune": "IMPORTER CARTOGRAPHIE",
      "export_tune": "Exporter Cartographie",
      "start_engine": "DÉMARRER MOTEUR",
      "rpm": "RPM",
      "147": "14.7",
      "afr": "AFR",
      "status": "Statut :",
      "off": "OFF",
      "map": "MAP :",
      "101_kpa": "101 kPa",
      "boost": "Boost :",
      "00_psi": "0.0 psi",
      "config": "Config :",
      "twin_turbo": "TWIN TURBO",
      "tps": "TPS :",
      "0": "0%",
      "timing": "Avance :",
      "knk_retard": "Retard KNK :",
      "knock_count": "Nombre de cliquetis :",
      "inj_pw_cyl_1": "Inj. PW (Cyl 1) :",
      "00_ms": "0.0 ms",
      "vvt_intake": "VVT Admission :",
      "vvt_exhaust": "VVT Échappement :",
      "coolant_temp": "Temp. Liquide :",
      "_": "+ / - / *",
      "ethanol": "Éthanol :",
      "fuel_rail": "Rampe de Carburant :",
      "_psi": "-- PSI",
      "stft": "STFT :",
      "pump_load": "Charge Pompe :",
      "battery": "Batterie :",
      "125_v": "12.5 V",
      "max_pedal_tps": "TPS Max Pédale",
      "100": "100%",
      "throttle_hold": "Maintien Accélérateur",
      "pedal": "PÉDALE",
      "ecu_flags": "DRAPEAUX ECU :",
      "engine_limits": "Limites Moteur",
      "trigger": "Déclencheur",
      "adv_uo": "Utilisateurs avancés uniquement !",
      "smart_alternator": "Alternateur Intelligent",
      "axis_wizard": "Assistant d'Axes",
      "ve_table": "Table VE",
      "target_afr_table": "Table AFR Cible",
      "fuel_settings": "Paramètres Carburant",
      "flex_fuel": "Flex Fuel",
      "closed_loop_fuel": "Carburant Boucle Fermée",
      "accel_enrichment": "Enrichissement Accél.",
      "ignition_advance": "Avance à l'Allumage",
      "ignition_settings": "Paramètres d'Allumage",
      "knock_control": "Contrôle Cliquetis",
      "vvt_intake_target": "Cible VVT Admission",
      "vvt_exhaust_target": "Cible VVT Échappement",
      "vvt_vtec_settings": "Paramètres VVT / VTEC",
      "idle": "Ralenti",
      "cranking": "Démarrage",
      "upgrades_mods": "Améliorations & Mods",
      "nitrous_system": "Système Nitreux",
      "wastegate_duty_table": "Table Cycle Wastegate",
      "cl_boost_target": "Cible Boost Boucle Fermée",
      "launch_control": "Contrôle de Départ",
      "simulation_settings": "Paramètres de Simulation",
      "simple": "SIMPLE",
      "adv": "ADV",
      "buy_advanced_mode": "Acheter Mode Avancé !",
      "log_off": "DÉCONNEXION",
      "selection_tools": "Outils de Sélection :",
      "interp_x_row": "Interp X (Ligne)",
      "interp_y_col": "Interp Y (Col)",
      "interp_2d_area": "Interp 2D (Zone)",
      "keys_hinterp_x_vinterp_y_iinterp_2d_gtlt": "Keys: H=Interp X · V=Interp Y · I=Interp 2D · &gt;/&lt;=±1 · +/-/*=math then Enter · Arrows=navigate · Ctrl+C/V=copy/paste · Ctrl+Z/Y=undo/redo",
      "ve_table_load_vs_rpm": "Table VE (Charge vs RPM)",
      "higher_numbers_more_fuel_adjust_to_hit_t": "Nombres élevés = plus de carburant. Ajustez pour atteindre l'AFR cible.",
      "target_afr_table_load_vs_rpm": "Table AFR Cible (Charge vs RPM)",
      "commanded_airfuel_ratio_core_part_of_the": "Rapport Air/Carburant commandé. Élément central de l'équation Speed Density.",
      "fuel_injector_settings": "Paramètres Carburant & Injecteurs",
      "injector_size_ccmin": "Taille Injecteur (cc/min)",
      "injector_reference_pressure_kpa": "Pression de Référence Injecteur (kPa)",
      "dead_time_ms_by_v": "Temps Mort (ms par V)",
      "c": "°C",
      "multiplier_at_each_iat_10_no_change_09_1": "Multiplicateur à chaque IAT. 1.0 = pas de changement, 0.9 = -10%, 1.1 = +10%.",
      "ect_fuel_enrichment_": "Enrichissement Carburant ECT (×)",
      "fuel_multiplier_on_cold_start_10_no_corr": "Multiplicateur carburant au démarrage à froid. 1.0 = pas de correction à temp de fonctionnement.",
      "fuel_octane": "Octane Carburant",
      "87_aki_regular": "87 AKI (Régulier)",
      "91_aki_premium": "91 AKI (Premium)",
      "93_aki_premium": "93 AKI (Premium+)",
      "100_aki_race_gas": "100 AKI (Race Gas)",
      "104_aki_race_gas": "104 AKI (Race Gas)",
      "116_aki_methanolrace": "116+ AKI (Méthanol/Race)",
      "display_afr_as_lambda_3_decimals": "Afficher l'AFR en Lambda (3 décimales)",
      "enable_fuel_pressure_model": "Activer le Modèle de Pression de Carburant",
      "base_fuel_pressure_psi": "Pression de Carburant de Base (PSI)",
      "fuel_system_type": "Type de Système de Carburant",
      "return_style_rising_rate": "Style avec Retour (taux croissant)",
      "returnless_fixed_pressure": "Sans Retour (pression fixe)",
      "return_style_rail_rises_11_with_boost_in": "Style avec retour : la pression monte 1:1 avec le boost. Sans retour : pression fixe, le débit injecteur chute sous boost.",
      "apply_settings": "Appliquer Paramètres",
      "ignition_timing_table_load_vs_rpm": "Table d'Allumage (Charge vs RPM)",
      "degrees_before_top_dead_center_too_much_": "Degrés avant Point Mort Haut. Trop d'avance cause du cliquetis.",
      "flex_fuel_sensor_simulation": "Simulation Capteur Flex Fuel",
      "moving_this_slider_simulates_adding_etha": "Déplacer ce curseur simule l'ajout d'éthanol. L'ECU ajustera automatiquement la masse de carburant.",
      "enable_flex_fuel_tuning_populate_flex_ta": "Activer le Tuning Flex Fuel",
      "ethanol_content_": "Teneur en Éthanol (%)",
      "apply_content": "Appliquer Teneur",
      "flex_fuel_ve_adder_": "Ajout VE Flex Fuel (%)",
      "blend_curve_0_100_x_base_map_map_vs_rpm": "Courbe de Mélange (0-100%) x Table de Base (MAP vs RPM)",
      "flex_fuel_afr_offset": "Décalage AFR Flex Fuel",
      "flex_fuel_timing_adder_deg": "Ajout Avance Flex Fuel (deg)",
      "flex_fuel_boost_duty_adder_": "Ajout Duty Boost Flex Fuel (%)",
      "blend_curve_0_100_x_base_map_tps_vs_rpm": "Courbe de Mélange (0-100%) x Table de Base (TPS vs RPM)",
      "closed_loop_fuel_stft": "Carburant Boucle Fermée (STFT)",
      "enable_closed_loop_correction": "Activer Correction Boucle Fermée",
      "deadband_": "Zone Morte (%)",
      "lambda_error_within_this_band_is_ignored": "L'erreur Lambda dans cette zone est ignorée.",
      "tps_lt_5_rpm_near_idle_target": "(TPS < 5%, RPM proche de cible ralenti)",
      "time_constant_s": "Constante de Temps (s)",
      "gain_00833_s": "Gain: 0.0833 /s",
      "min_correction_": "Correction Min (%)",
      "max_correction_": "Correction Max (%)",
      "part_throttle_cruise": "(mi-accélérateur / croisière)",
      "gain_01250_s": "Gain: 0.1250 /s",
      "tps_gt_90": "(TPS > 90%)",
      "gain_02000_s": "Gain: 0.2000 /s",
      "acceleration_enrichment": "Enrichissement à l'Accélération",
      "corrects_fueling_during_rapid_throttle_o": "Corrige le carburant lors des ouvertures rapides du papillon.",
      "mode": "MODE :",
      "none_disabled": "Aucun (Désactivé)",
      "ms_adder": "Ajout MS",
      "map_prediction": "Prédiction MAP",
      "accel_time_s": "Temps Accél. (s)",
      "hard_cutoff_duration_of_enrichment_event": "Hard cutoff duration of enrichment event",
      "decay_rate": "Taux de Décroissance",
      "ms_mode_mss_middot_map_mode_blends": "MS mode: ms/s &middot; MAP mode: blend/s",
      "ms_adder_dtps_s_vs_rpm_rarr_ms": "Ajout MS (dTPS %/s vs RPM → ms)",
      "extra_injection_ms_on_tip_in_y_tps_rate_": "Injection supplémentaire en ms au coup d'accélérateur.",
      "map_prediction_tps_vs_rpm_rarr_kpa": "Prédiction MAP (TPS % vs RPM → kPa)",
      "predicted_map_for_veafrtiming_lookups_du": "Predicted MAP for VE/AFR/timing lookups during tip-in. Y = TPS %, X = RPM.",
      "ignition_system_mode": "Mode Système Allumage",
      "sets_coil_topology_recharge_time_and_mel": "Sets coil topology, recharge time, and melt behavior.",
      "distributor_single_coil": "Distributeur (Bobine Unique)",
      "wasted_spark_n2_coils": "Étincelle Perdue (N/2 Bobines)",
      "fully_sequential_cop": "Séquentiel Complet / COP",
      "spark_plug_gap_inches": "Écartement Bougies (pouces)",
      "wider_gap_needs_more_dwell_to_fire_under": "Wider gap = needs more dwell to fire. Under boost, effective gap shrinks 0.005&quot; per 10 psi — tighter gaps recommended on boosted builds.",
      "degrees_of_retard_at_each_iat_0_no_retar": "Degrés de retard à chaque IAT. 0 = pas de retard.",
      "coil_dwell_time_ms_by_battery_v": "Temps de Charge Bobine (ms par Batterie V)",
      "coil_charge_time_low_voltage_during_cran": "Coil charge time. Low voltage during cranking may cause weak spark.",
      "knock_sensor_spectrogram": "Spectrogramme Capteur Cliquetis",
      "pause": "PAUSE",
      "cyan_noise_level_nbspnbsp_red_dashed_thr": "Cyan = niveau de bruit | Rouge pointillé = seuil",
      "_25s": "-2.5s",
      "now": "Maintenant",
      "knock_threshold_db_vs_rpm": "Seuil Cliquetis (dB vs RPM)",
      "noise_level_above_which_a_knock_event_tr": "Noise level above which a knock event triggers retard. At idle background noise is ~-26 dB; knock spikes to ~-2 dB.\n                                Set each cell just below the lowest knock spike at that RPM. Default -10 dB is a good starting point at lower RPM.\n                                At high RPM you may need to lower to -15 dB or below to avoid false positives.",
      "control_parameters": "Paramètres de Contrôle",
      "enable_knock_control": "Activer Contrôle Cliquetis",
      "complete_knock_frequency_calibration_bel": "Complete Knock Frequency Calibration below to unlock.",
      "attack_degevent": "Attaque (deg/événement)",
      "degrees_removed_per_knock_detection_0510": "Degrees removed per knock detection. 0.5–10°",
      "max_retard_deg": "Retard Max (deg)",
      "maximum_accumulated_retard_120": "Maximum accumulated retard. 1–20°",
      "recovery_rate_degrev": "Taux de Récupération (deg/rev)",
      "degrees_recovered_per_engine_revolution_": "Degrees recovered per engine revolution. 0.1–2.0",
      "min_tps_to_engage_": "TPS Min pour Activer (%)",
      "suppresses_retard_below_this_throttle_po": "Suppresses retard below this throttle position. Prevents false triggers on decel pops.",
      "min_map_to_engage_kpa": "MAP Min pour Activer (kPa)",
      "suppresses_retard_below_this_manifold_pr": "Suppresses retard below this manifold pressure. 60 kPa ≈ light cruise.",
      "knock_control_frequency_calibration_mode": "Mode Calibration Fréquence Cliquetis",
      "enter_calibration_mode": "Entrer en Mode Calibration",
      "identify_the_engines_natural_knock_reson": "Identifiez la fréquence de résonance naturelle du moteur.",
      "formula_f_573_boremm_nbspnbsp_81_mm_bore": "Formula: f ≈ 573 ÷ bore_mm &nbsp;|&nbsp; 81 mm bore ≈ 7.07 kHz &nbsp;|&nbsp; 102 mm bore ≈ 5.61 kHz",
      "20k": "20k",
      "15k": "15k",
      "10k": "10k",
      "5k": "5k",
      "_5_seconds_ago": "← 5 seconds ago",
      "now_": "Now →",
      "center_freq_khz": "Fréq. Centrale (kHz)",
      "khz": "kHz",
      "temp_timing_adder": "Ajout Avance Temp.",
      "_for": "° for",
      "s": "s",
      "apply": "Appliquer",
      "confirm_calibration": "Confirmer Calibration",
      "recalibrate": "Recalibrer",
      "nitrous_oxide_system": "Système de Protoxyde d'Azote",
      "upgrades_amp_mods": "Améliorations & Mods",
      "n2o_jet_size_thousandths_in": "Taille Gicleur N2O (millièmes de pouce)",
      "estimated_power": "Puissance Estimée",
      "_337_hp": "≈ 33.7 HP",
      "fuel_jet_size_thousandths_in": "Taille Gicleur Carburant (millièmes de pouce)",
      "wet_shot_fuel_solenoid_handles_base_enri": "Wet shot: fuel solenoid handles base enrichment. ECU VE comp adds on top.",
      "activation_mode": "Mode d'Activation",
      "button_switch": "Bouton / Interrupteur",
      "ecu_control": "Contrôle ECU",
      "ecu_control_parameters": "Paramètres Contrôle ECU",
      "min_tps_": "TPS Min (%)",
      "min_rpm": "RPM Min",
      "max_rpm": "RPM Max",
      "max_map_kpa": "MAP Max (kPa)",
      "afr_safety_cut_lean": "Coupure Sécurité AFR (pauvre)",
      "fuel_ve_comp_": "Comp. VE Carburant (%)",
      "extra_fuel_when_n2o_is_active_dry_primar": "Extra fuel when N2O is active. Dry = primary comp. Wet = supplement on top of fuel solenoid.",
      "timing_retard_": "Retard Allumage (°)",
      "degrees_pulled_from_commanded_timing_whe": "Degrees pulled from commanded timing when N2O is active.",
      "apply_nitrous_settings": "Appliquer Paramètres Nitreux",
      "vvt_intake_advance_target_load_vs_rpm": "Cible Avance VVT Admission (Charge vs RPM)",
      "positive_degrees_of_intake_cam_advance_i": "Positive degrees of intake cam advance. Interpolates absolute \"In_X\" engine maps.",
      "vvt_exhaust_retard_target_load_vs_rpm": "Cible Retard VVT Échappement (Charge vs RPM)",
      "negative_degrees_of_exhaust_cam_retard_i": "Negative degrees of exhaust cam retard. Interpolates absolute \"Ex_X\" engine maps.",
      "variable_valve_lift_vvl_vtec": "Levée de Valve Variable (VVL / VTEC)",
      "vvl_high_cam_switch_rpm": "RPM Basculement VVL / Came Haute",
      "vvl_high_cam_min_tps_": "TPS Min Came Haute VVL (%)",
      "vvl_fuel_adder_ve_": "Ajout Carburant VVL (VE %)",
      "vvl_timing_adder_": "Ajout Allumage VVL (°)",
      "continuous_vvt_phase_angles_are_controll": "Continuous VVT phase angles are controlled via the 9x9 tables.",
      "closed_loop_pid_control": "Contrôle PID Boucle Fermée",
      "enable_closed_loop_pid_control": "Activer Contrôle PID Boucle Fermée",
      "proportional_kp": "Proportionnel (Kp)",
      "integral_ki": "Intégral (Ki)",
      "derivative_kd": "Dérivé (Kd)",
      "higher_kp_faster_response_ki_eliminates_": "Higher Kp = faster response. Ki eliminates steady-state error. Kd damps overshoot. Live display shows actual° / target° when enabled.",
      "wastegate_duty_table_tps_vs_rpm": "Table Cycle Wastegate (TPS vs RPM)",
      "commanded_wastegate_solenoid_duty_cycle_": "Commanded wastegate solenoid duty cycle (0–100%). Higher duty = more boost. Requires a turbocharger mod installed. In Closed-Loop Boost mode this table acts as the feed-forward base; the PID trims on top.",
      "cl_boost_target_table_tps_vs_rpm": "Table Cible Boost Boucle Fermée (TPS vs RPM)",
      "target_boost_pressure_in_psi_used_when_c": "Target boost pressure in PSI. Used when Closed-Loop Boost is enabled in Mod Settings. 0 = match wastegate spring pressure. The WG Duty table is the feed-forward base; the PID adjusts duty to hit this target.",
      "rev_limit_rpm": "Limite RPM",
      "rev_limit_hysteresis_rpm": "Hystérésis Limite RPM",
      "fuel_cut": "Coupure Carburant",
      "spark_cut": "Coupure Allumage",
      "enable_decel_fuel_cut": "Activer Coupure Carburant Décél.",
      "cut_delay_sec": "Délai Coupure (Sec)",
      "boost_protection": "Protection Boost",
      "boost_cut_psi": "Coupure Boost (psi)",
      "hysteresis_psi": "Hystérésis (psi)",
      "trigger_calibration": "Calibration Déclencheur",
      "timing_light_mode": "Mode Lampe Stroboscopique",
      "simulates_a_timing_light_check_engine_st": "Simulates a timing light check. Engine start is disabled while active.",
      "must_match_engine_base_offset_affects_ti": "must match engine base offset — affects timing at all times",
      "fixed_timing_ecu_commanded_045_btdc": "Fixed Timing — ECU commanded (0–45° BTDC)",
      "enable_smart_alternator": "Activer Alternateur Intelligent",
      "alt_pressure_rises_05_v_per_1000_rpm_pid": "Alt pressure rises +0.5 V per 1000 RPM. PID controls duty to hold target voltage.",
      "p_gain": "Gain P",
      "i_gain": "Gain I",
      "d_gain": "Gain D",
      "alternator_duty": "Cycle Alternateur :",
      "na": "N/A",
      "axis_setup_wizard": "Assistant de Configuration d'Axes",
      "sets_the_16_point_rpm_and_map_load_axes_": "Sets the 16-point RPM and MAP (load) axes for the VE, AFR, and Timing tables. WG Duty table columns (RPM) also update. The WG Duty row axis (TPS) is unaffected.",
      "base_rpm": "RPM de Base",
      "base_kpa_min_load": "kPa de Base (charge min)",
      "max_kpa": "kPa Max",
      "apply_axis_wizard": "Appliquer Assistant Axes",
      "reset_to_default": "Réinitialiser",
      "note_existing_tune_values_are_interpolat": "Note: existing tune values are interpolated/extrapolated onto the new axes. Values beyond your current range are linearly extrapolated from the edge trend.",
      "idle_settings": "Paramètres de Ralenti",
      "maximum_idle_tps": "TPS Ralenti Maximum",
      "actual_throttle_when_duty_curve_reads_10": "Actual throttle % when duty curve reads 100%.",
      "idle_control_rpm_upper_limit": "Limite Supérieure RPM Contrôle Ralenti",
      "idle_control_disengages_above_target_rpm": "Idle control disengages above Target RPM + this value.",
      "target_idle_rpm_vs_coolant_temp": "Cible RPM Ralenti vs Temp. Liquide",
      "idle_rpm_target_by_coolant_temperature_r": "Idle RPM target by coolant temperature. Runs higher when cold.",
      "idle_duty_vs_coolant_temp_": "Duty Ralenti vs Temp. Liquide (%)",
      "_of_maximum_idle_tps_to_command_at_each_": "% of Maximum Idle TPS% to command at each coolant temperature.",
      "closed_loop_idle_ignition": "Allumage Ralenti Boucle Fermée",
      "uses_ignition_timing_to_maintain_target_": "Uses ignition timing to maintain target idle RPM for faster corrections.",
      "p": "P",
      "i": "I",
      "d": "D",
      "cranking_starting": "Démarrage",
      "base_ve": "VE de Base",
      "max_crank_rpm": "RPM Max Démarrage",
      "decay_s": "Décroissance (s)",
      "crank_time_s": "Temps de Démarrage (s)",
      "cranking_idle_air_duty_vs_coolant_temp_": "Duty Air Ralenti Démarrage vs Temp. Liquide (%)",
      "throttle_position_air_during_cranking_hi": "Throttle position (air) during cranking. Higher when cold to overcome friction.",
      "post_crank_enrichment_vs_coolant_temp_ve": "Enrichissement Post-Démarrage vs Temp. Liquide (×VE)",
      "fuel_multiplier_applied_immediately_afte": "Fuel multiplier applied immediately after cranking ends. 1.0 = no enrichment.",
      "post_crank_decay_cycles": "Cycles Décroissance Post-Démarrage",
      "engine_cycles_720_each_for_enrichment_to": "Engine cycles (720° each) for enrichment to decay from curve value to 1.0×.",
      "vehicle_upgrades": "Améliorations Véhicule",
      "export_mod_list": "EXPORTER LISTE MODS",
      "import_mod_list": "IMPORTER LISTE MODS",
      "mod_collection": "Collection de Mods",
      "tuner_warning_extreme_mods_like_heavy_ca": "TUNER WARNING: Extreme mods like heavy cams will increase idle vacuum penalty (raises base MAP), which can stall your engine! You will need to tune your low-RPM fuel/timing and raise target idle RPM to compensate.",
      "launch_control_two_step": "Contrôle de Départ / Two-Step",
      "enable_launch_control": "Activer Contrôle de Départ",
      "launch_rpm": "RPM de Départ",
      "hysteresis_rpm": "Hystérésis (RPM)",
      "window_size_rpm": "Taille de la Fenêtre (RPM)",
      "cut_type": "Type de Coupure",
      "ignition_cut": "Coupure Allumage",
      "both_hard_cut": "Les deux (Coupure Nette)",
      "window_start_timing_deg": "Avance Début Fenêtre (deg)",
      "limit_timing_deg_absolute": "Limite Avance (deg absolu)",
      "fuel_adder_afr_": "Ajout Carburant (AFR %)",
      "activate_two_step_mode_switch": "Activer Commutateur Mode Two-Step",
      "test_your_launch_settings_in_the_garage_": "Test your launch settings in the garage. When active, the engine will limit to Launch RPM at full throttle even in Neutral.",
      "ambient_conditions_used_as_the_baseline_": "Ambient conditions used as the baseline for all simulations — dyno pulls, drag runs, and the garage physics loop.",
      "unit_system": "Système d'Unités",
      "affects_all_displayed_temperatures_press": "Affects all displayed temperatures, pressures, and speed. AFR/Lambda can be toggled separately by clicking the gauge.",
      "pressure_display_mode": "Mode d'Affichage de Pression",
      "absolute": "Absolu",
      "gauge": "Relatif",
      "switches_pressure_on_y_axes_and_gauges": "Bascule la pression sur les axes Y et les jauges entre pression absolue et relative. Les calculs internes utilisent toujours le kPa absolu.",
      "ambient_temperature_f": "Température Ambiante (°F)",
      "ambient_temperature_c": "Température Ambiante (°C)",
      "sets_base_iat_for_the_physics_loop": "Sets base IAT for the physics loop.",
      "barometric_pressure_kpa": "Pression Barométrique (kPa)",
      "affects_map_ceiling_and_airmass_scaling_": "Affects MAP ceiling and airmass scaling (altitude).",
      "relative_humidity_": "Humidité Relative (%)",
      "used_for_dyno_correction_factor_sae_std": "Used for dyno correction factor (SAE / STD).",
      "coolant_temperature_simulation": "Simulation Température Liquide",
      "enable_ect_simulation": "Activer Simulation ECT",
      "when_enabled_engine_starts_cold_at_ambie": "Lorsqu'activé, le moteur démarre à froid à la température ambiante et chauffe jusqu'à 90 °C. Désactivé = ECT bloqué à 90 °C.",
      "o2_sensor_simulation": "Simulation Sonde O2",
      "enable_o2_transport_delay_amp_combustion": "Activer le retard de transport O2 et le bruit de combustion",
      "adds_exhaust_transport_delay_to_afr_disp": "Ajoute un retard de transport des gaz d'échappement à l'affichage AFR (300ms au ralenti, 0ms à 3500 tr/min) et une variance de combustion de ±3% à bas régime.",
      "starter_mode": "Mode Démarreur",
      "hold_to_engage_hold_the_button_while_the": "Hold to Engage: hold the button while the starter cranks; release after engine fires.",
      "knock_indicator": "Indicateur de Cliquetis",
      "show_knock_event_indicator_overlay": "Afficher l'indicateur d'événement de cliquetis",
      "floating_counter_shown_in_all_views_when": "Compteur flottant affiché dans toutes les vues lorsque le moteur cliquète. En mode Avancé, utilisez l'onglet Contrôle du cliquetis.",
      "transmission_selection": "Sélection de Transmission",
      "export": "EXPORTER",
      "custom_ratios": "Rapports Personnalisés",
      "final_drive_ratio": "RAPPORT DE PONT FINAL",
      "gear_1": "VIT. 1",
      "gear_2": "VIT. 2",
      "gear_3": "VIT. 3",
      "gear_4": "VIT. 4",
      "gear_5": "VIT. 5",
      "gear_6": "VIT. 6",
      "gear_7": "VIT. 7",
      "gear_8": "VIT. 8",
      "gear_9": "VIT. 9",
      "gear_10": "VIT. 10",
      "set_ratio_to_0_to_disable_a_gear": "Set ratio to 0 to disable a gear.",
      "apply_simulation_settings": "Appliquer Paramètres Simulation",
      "virtual_dynamometer": "Dynamomètre Virtuel",
      "loads_the_engine_dynamically_to_perform_": "Loads the engine dynamically to perform a real-time full-throttle sweep from start RPM to redline.",
      "auto_log_off": "AUTO-LOG OFF",
      "set_as_reference": "DÉFINIR COMME RÉFÉRENCE",
      "hold_n2o": "MAINTENIR N2O",
      "smoothing": "LISSAGE :",
      "0_raw": "0 (Brut)",
      "5_max": "5 (Max)",
      "correction": "CORRECTION :",
      "none": "Aucune",
      "sae": "SAE",
      "std": "STD",
      "load_dyno": "Charger Dyno",
      "rpm_lock": "Blocage RPM",
      "dynojet": "Dynojet",
      "rpms": "RPM/S :",
      "target_rpm": "RPM CIBLE :",
      "afr_guideline": "GUIDE AFR :",
      "start_rpm": "RPM DÉBUT :",
      "ambient_conditions_advanced_simulation_s": "Ambient conditions: Advanced → Simulation Settings",
      "leaderboard_display_name": "Nom d'Affichage Classement",
      "submit_to_leaderboard": "Soumettre au Classement",
      "clutch_0": "EMBRAYAGE : 0%",
      "run": "DÉPART",
      "launch": "LANCEMENT",
      "60ft": "60ft",
      "330ft": "330ft",
      "18_mile": "1/8 Mile",
      "1000ft": "1000ft",
      "14_mile": "1/4 Mile",
      "reaction_time": "Temps de Réaction",
      "9872_check_run_category": "&#9872; Check Run Category",
      "sim_config": "Config Sim",
      "weight_lbs": "Poids (lbs)",
      "shift_rpm": "RPM de Passage",
      "shift_delay_s": "Délai Passage (s)",
      "tires": "Pneus",
      "economy": "Économie",
      "street": "Rue",
      "summer": "Été",
      "drag_radials": "Drag Radials",
      "drag_slicks": "Drag Slicks",
      "clutch_slip_s": "Patinage Embrayage (s)",
      "lb_class": "Classe LB",
      "run_controls": "Contrôles de Course",
      "start_1x": "DÉPART (1x)",
      "ff_3x": "FF (3x)",
      "instant": "INSTANTANÉ",
      "shift_up": "VITESSE SUP",
      "abort": "ABANDON",
      "n2o": "N2O",
      "manual_mode": "Mode Manuel",
      "no_shift_on_slip": "Pas de passage si patinage",
      "auto_log": "Auto-Log",
      "hold_cspace_on_line_release_c_to_launch_": "Hold C+SPACE on line → release C to launch &nbsp;|&nbsp; SPACE=throttle &nbsp;C=clutch &nbsp;S=shift↑ &nbsp;X=shift↓",
      "requirement": "Exigence :",
      "logged_in": "connecté",
      "advanced_mode": "Mode Avancé",
      "default_vehicle_weight": "Poids Véhicule par Défaut",
      "01s_shift_delay": "0.1s Délai de Passage",
      "engine": "Moteur",
      "category": "Catégorie",
      "stock_economy": "Stock — Économie",
      "stock_street": "Stock — Rue",
      "stock_summer": "Stock — Été",
      "stock_drag_radials": "Stock — Drag Radials",
      "stock_drag_slicks": "Stock — Drag Slicks",
      "mod_na_economy": "Mod N/A — Économie",
      "mod_na_street": "Mod N/A — Rue",
      "mod_na_summer": "Mod N/A — Été",
      "mod_na_drag_radials": "Mod N/A — Drag Radials",
      "mod_na_drag_slicks": "Mod N/A — Drag Slicks",
      "power_adder_economy": "Power Adder — Économie",
      "power_adder_street": "Power Adder — Rue",
      "power_adder_summer": "Power Adder — Été",
      "power_adder_drag_radials": "Power Adder — Drag Radials",
      "power_adder_drag_slicks": "Power Adder — Drag Slicks",
      "super_pa_economy": "Super PA — Économie",
      "super_pa_street": "Super PA — Rue",
      "super_pa_summer": "Super PA — Été",
      "super_pa_drag_radials": "Super PA — Drag Radials",
      "super_pa_drag_slicks": "Super PA — Drag Slicks",
      "search": "Rechercher",
      "knock_detected": "Cliquetis Détecté",
      "0_events": "0 événements",
      "v001": "v0.0.1",
      "1_2": "1 / 2",
      "times": "×",
      "simple_mode_vs_advanced_mode": "Mode Simple vs Mode Avancé",
      "free": "(Gratuit)",
      "purchased": "(Acheté)",
      "click_here_to_get_advanced_mode_": "Cliquez ici pour le Mode Avancé →",
      "extra_engines_amp_mods": "Moteurs & Mods Supplémentaires",
      "click_here_to_browse_engines_": "Cliquez ici pour les Moteurs →",
      "click_here_to_browse_mods_": "Cliquez ici pour les Mods →",
      "128274_log_in_to_access_your_purchases": "&#128274; Log In to Access Your Purchases",
      "alphax_account": "Compte AlphaX",
      "alphaxprcom": "alphaxpr.com",
      "controls": "Controles",
      "space": "Espace",
      "click_drag": "Clic / Glisser",
      "click_cell": "Clic cellule",
      "ctrlz_y": "Ctrl+Z / Y",
      "table_keyboard_shortcuts": "Raccourcis Clavier Table",
      "arrows": "Flèches",
      "gt_lt": "&gt; / &lt;",
      "h": "H",
      "v": "V",
      "ctrlc_v": "Ctrl+C / V",
      "datalogging": "Datalogging",
      "basic_tuning_tips": "Conseils de Tuning de Base",
      "ignition_timing": "Allumage",
      "target_afr": "AFR Cible",
      "map_axis": "Eje MAP",
      "_back": "← Retour",
      "controls_": "Controles →",
      "got_it_": "Compris ! ✓",
      "run_category_check": "Run Category Check",
      "close": "Fermer",
      "save_your_tune": "Sauvegarder Carto",
      "you_have_unsaved_tuning_changes": "Changements non sauvegardés.",
      "export_your_tune_before_closing_so_you_c": "Export your tune before closing so you can reload it later.",
      "dismiss": "Ignorer",
      "keep_adjusting": "Continuer Ajustement",
      "timing_is_correct_": "Allumage Correct ✓",
      "commanded_wastegate_solenoid_duty_cycle": "Commanded wastegate solenoid duty cycle (0–100%). Higher duty = more boost. Requires a turbocharger mod installed. In Closed-Loop Boost mode this table acts as the feed-forward base; the PID trims on top.",
      "integrates_the_lambda_error_between_actu": "Integrates the lambda error between actual and target AFR each frame and applies a Short-Term Fuel Trim multiplier to correct fueling. Uses your Target AFR table as the setpoint. The integrator gain is",
      "dry_shot_switch_mode_no_ecu_compensation": "Dry shot, switch mode: no ECU compensation is applied. Bake your fuel and timing corrections directly into your VE and timing maps.",
      "sets_the_16_point_rpm_and_map_load_axes": "Sets the 16-point RPM and MAP (load) axes for the VE, AFR, and Timing tables. WG Duty table columns (RPM) also update. The WG Duty row axis (TPS) is unaffected.",
      "keys_hinterp_x_vinterp_y_iinterp_2d_1_ma": "Keys: H=Interp X · V=Interp Y · I=Interp 2D · &gt;/&lt;=±1 · +/-/*=math then Enter · Arrows=navigate · Ctrl+C/V=copy/paste · Ctrl+Z/Y=undo/redo",
      "higher_kp_faster_response_ki_eliminates": "Higher Kp = faster response. Ki eliminates steady-state error. Kd damps overshoot. Live display shows actual° / target° when enabled.",
      "formula_f_573_boremm_81_mm_bore_707_khz": "Formula: f ≈ 573 ÷ bore_mm &nbsp;|&nbsp; 81 mm bore ≈ 7.07 kHz &nbsp;|&nbsp; 102 mm bore ≈ 5.61 kHz",
      "test_your_launch_settings_in_the_garage": "Test your launch settings in the garage. When active, the engine will limit to Launch RPM at full throttle even in Neutral.",
      "hold_cspace_on_line_release_c_to_launch": "Hold C+SPACE on line → release C to launch &nbsp;|&nbsp; SPACE=throttle &nbsp;C=clutch &nbsp;S=shift↑ &nbsp;X=shift↓",
      "ambient_conditions_used_as_the_baseline": "Ambient conditions used as the baseline for all simulations — dyno pulls, drag runs, and the garage physics loop.",
      "mods_include_turbochargers_camshafts_coo": "Mods include turbochargers, camshafts, cooling upgrades, and more — each with real physics effects.",
      "loads_the_engine_dynamically_to_perform": "Loads the engine dynamically to perform a real-time full-throttle sweep from start RPM to redline.",
      "each_engine_has_its_own_power_curve_knoc": "Each engine has its own power curve, knock limits, compression ratio, and tuning maps.",
      "trigger_angle_offset_ecu_360360": "Trigger Angle Offset — ECU (-360–360°)",
      "55_sub_axes_derived_from_the_main_rpm_an": "5×5 sub-axes derived from the main RPM and MAP axes. Scales with the Axis Wizard.",
      "advanced_mode_activates_automatically_wh": "Advanced Mode activates automatically when your purchase is detected at login.",
      "trigger_offset_matches_engine_base_the_t": "Trigger offset matches engine base — the timing mark is perfectly aligned.",
      "inj_mismatch": "Injector size mismatch — check Fuel Settings matches installed injectors",
      "uses_ignition_timing_to_maintain_target": "Uses ignition timing to maintain target idle RPM for faster corrections.",
      "on_the_store_for_the_simulator_to_detect": "on the store for the simulator to detect your purchases and unlock them.",
      "engine_load_in_kpa_higher_more_load_mor": "— engine load in kPa. Higher = more load = more fuel &amp; timing needed",
      "if_you_purchased_something_and_dont_see": "If you purchased something and don't see it, log in to your account on",
      "cyan_noise_level_red_dashed_threshold_at": "Cyan = noise level &nbsp;|&nbsp; Red dashed = threshold at current RPM",
      "torque_bonus_0_at_145_v_3_at_125_v_reduc": "Torque bonus: 0% at 14.5 V → +3% at 12.5 V (reduced alternator drag).",
      "extra_injection_ms_on_tip_in_y_tps_rate": "Extra injection ms on tip-in. Y = TPS rate of change (%/s), X = RPM.",
      "your_purchased_engines_mods_and_advanced": "Your purchased engines, mods, and Advanced Mode are tied to your",
      "logs_include_rpm_map_afr_timing_ve_torqu": "Logs include RPM, MAP, AFR, timing, VE, torque, boost, and more",
      "advance_for_power_but_watch_for_knock_t": "— advance for power, but watch for knock. Typical MBT is 25–35°",
      "degrees_before_top_dead_center_too_much": "Degrees Before Top Dead Center. Too much advance causes knock.",
      "of_maximum_idle_tps_to_command_at_each": "% of Maximum Idle TPS% to command at each coolant temperature.",
      "richer_11121_under_boostwot_stoich_1471": "— richer (11–12:1) under boost/WOT, stoich (14.7:1) at cruise",
      "controls_fuel_delivery_aim_for_1471_afr": "— controls fuel delivery. Aim for ~14.7:1 AFR at cruise",
      "to_submit_runs_must_use": "to submit. \n                            Runs must use",
      "flood_hint": "Hold throttle to floor while cranking to clear flood",
      "affects_map_ceiling_and_airmass_scaling": "Affects MAP ceiling and airmass scaling (altitude).",
      "select_an_engine_and_category_to_view_le": "Select an engine and category to view leaderboards.",
      "degrees_recovered_per_engine_revolution": "Degrees recovered per engine revolution. 0.1–2.0",
      "enable_o2_transport_delay_combustion_noi": "Enable O2 Transport Delay &amp; Combustion Noise",
      "focus_math_input_type_value_enter_to_ap": "— Focus math input → type value → Enter to apply",
      "start_dyno_pull": "START DYNO PULL",
      "drag_strip_leaderboards": "Drag Strip Leaderboards",
      "copy_paste_selection_as_spreadsheet_dat": "— Copy / paste selection as spreadsheet data",
      "to_start_recording_stops_and_exports_a_c": "to start recording — stops and exports a CSV",
      "10003_ve_timing_target_afr_tables": "&#10003; VE, Timing &amp; Target AFR tables",
      "10003_flex_fuel_tables_e85_physics": "&#10003; Flex Fuel tables &amp; E85 physics",
      "interpolate_horizontally_across_selecti": "— Interpolate horizontally across selection",
      "cranking_idle_air_duty_vs_coolant_temp": "Cranking Idle Air Duty vs Coolant Temp (%)",
      "interpolate_vertically_across_selection": "— Interpolate vertically across selection",
      "available_in_garage_dyno_and_drag_modes": "Available in Garage, Dyno, and Drag modes",
      "ms_mode_mss_map_mode_blends": "MS mode: ms/s &middot; MAP mode: blend/s",
      "map_prediction_tps_vs_rpm_kpa": "MAP Prediction (TPS % vs RPM &rarr; kPa)",
      "10003_engine_damage_failure_rng": "&#10003; Engine damage &amp; failure RNG",
      "timing_is_correct": "Timing is Correct ✓",
      "imperial_f_psi_mph": "Imperial (°F &middot; PSI &middot; MPH)",
      "move_selection_hold_shift_to_extend": "— Move selection (hold Shift to extend)",
      "interpolate_2d_entire_selected_area": "— Interpolate 2D (entire selected area)",
      "select_a_dry_or_wet_shot_system_under": "Select a Dry or Wet Shot System under",
      "10003_launch_control_two_step": "&#10003; Launch control &amp; two-step",
      "add_subtract_1_from_selected_cells": "— Add / subtract 1 from selected cells",
      "target_voltage_v_rpm_vs_map_kpa": "Target Voltage (V) — RPM vs MAP (kPa)",
      "to_get_them": "to get them!",
      "metric_c_kpa_kph": "Metric (°C &middot; kPa &middot; KPH)",
      "10003_knock_detection_retard": "&#10003; Knock detection &amp; retard",
      "ms_adder_dtps_s_vs_rpm_ms": "MS Adder (dTPS %/s vs RPM &rarr; ms)",
      "to_qualify": "to qualify.",
      "10003_everything_in_simple_plus": "&#10003; Everything in Simple, plus:",
      "10003_accel_enrichment_ms_map": "&#10003; Accel enrichment (ms / MAP)",
      "tps_5_rpm_near_idle_target": "(TPS &lt; 5%, RPM near idle target)",
      "10003_dyno_drag_simulation": "&#10003; Dyno &amp; Drag simulation",
      "10003_coil_dwell_misfire_physics": "&#10003; Coil dwell misfire physics",
      "10003_vvt_vvl_cam_control": "&#10003; VVT &amp; VVL cam control",
      "10003_closed_loop_boost_control": "&#10003; Closed-loop boost control",
      "calibrated_center_frequency": "✓ Calibrated — center frequency:",
      "need_some_mods_head_over_to_the": "Need some mods? Head over to the",
      "10003_datalogging_csv_export": "&#10003; Datalogging (CSV export)",
      "10003_o2_sensor_delay_modeling": "&#10003; O2 sensor delay modeling",
      "10003_drag_racing_leaderboards": "&#10003; Drag racing leaderboards",
      "click_here_to_get_advanced_mode": "Click Here to get Advanced Mode →",
      "dont_show_again": "Don't show again",
      "map_load_axis_16_points_kpa": "MAP / Load Axis (16 points, kPa)",
      "flex_fuel_boost_duty_adder": "Flex Fuel Boost Duty Adder (%)",
      "10003_basic_closed_loop_afr": "&#10003; Basic closed-loop AFR",
      "click_here_to_browse_engines": "Click Here to browse Engines →",
      "idle_duty_vs_coolant_temp": "Idle Duty vs Coolant Temp (%)",
      "10003_tune_import_export": "&#10003; Tune import / export",
      "10003_smart_alternator_pid": "&#10003; Smart alternator PID",
      "no_nitrous_system_installed": "No nitrous system installed.",
      "10003_fuel_pressure_model": "&#10003; Fuel pressure model",
      "click_here_to_browse_mods": "Click Here to browse Mods →",
      "edit_a_tuning_table_value": "— Edit a tuning table value",
      "iat_timing_retard_by_iat": "IAT Timing Retard (by IAT",
      "vvl_high_cam_min_tps": "VVL / High Cam Min TPS (%)",
      "10003_idle_ignition_pid": "&#10003; Idle ignition PID",
      "extra_engines_mods": "Extra Engines &amp; Mods",
      "then_reload_this_page": ", then reload this page.",
      "hold_to_rev_the_engine": "— Hold to rev the engine",
      "ect_fuel_enrichment": "ECT Fuel Enrichment (×)",
      "10003_decel_fuel_cut": "&#10003; Decel fuel cut",
      "flex_fuel_ve_adder": "Flex Fuel VE Adder (%)",
      "iat_ve_comp_by_iat": "IAT VE Comp% (by IAT",
      "min_tps_to_engage": "Min TPS to Engage (%)",
      "vvl_fuel_adder_ve": "VVL Fuel Adder (VE %)",
      "voltage_regulator_pid": "Voltage Regulator PID",
      "relative_humidity": "Relative Humidity (%)",
      "modified_violations": "Modified+ violations:",
      "vvl_timing_adder": "VVL Timing Adder (°)",
      "rpm_axis_16_points": "RPM Axis (16 points)",
      "active_session_id": "Active Session ID:",
      "ethanol_content": "Ethanol Content (%)",
      "min_correction": "Min Correction (%)",
      "max_correction": "Max Correction (%)",
      "fuel_adder_afr": "Fuel Adder (AFR %)",
      "fuel_ve_comp": "Fuel VE Comp. (%)",
      "timing_retard": "Timing Retard (°)",
      "9888_red_light": "&#9888; RED LIGHT",
      "and_a_minimum_of": "and a minimum of",
      "timing_locked_in": "Timing Locked In!",
      "1_timeconstant": "1 / timeConstant",
      "throttle_pedal": "— Throttle pedal",
      "5_seconds_ago": "← 5 seconds ago",
      "live_telemetry": "LIVE TELEMETRY",
      "tps_90": "(TPS &gt; 90%)",
      "hold_to_engage": "Hold to Engage",
      "peak_boost": "PEAK BOOST: --",
      "ready_to_stage": "READY TO STAGE",
      "running_mode": "Running Mode",
      "push_to_start": "Push to Start",
      "undo_redo": "— Undo / Redo",
      "to_run_stock": "To run Stock:",
      "not_you": "! Not you? (",
      "firing_order": "FIRING ORDER",
      "deadband": "Deadband (%)",
      "you_must_be": "You must be",
      "simple_mode": "Simple Mode",
      "distributor": "DISTRIBUTOR",
      "n2o_active": "N2O: ACTIVE",
      "fuel_air": "Carburant & Air",
      "vvt_cams": "VVT & Cames",
      "min_tps": "Min TPS (%)",
      "peak_hp": "PEAK HP: --",
      "peak_tq": "PEAK TQ: --",
      "clutch_slip": "CLUTCH SLIP",
      "clutch_fail": "CLUTCH FAIL",
      "vvl_vtec": "VVL / VTEC",
      "idle_mode": "Idle Mode",
      "ref_hp": "REF HP: --",
      "ref_tq": "REF TQ: --",
      "and_using": "and using",
      "decel_cut": "DECEL CUT",
      "ignition": "Allumage",
      "advanced": "Avancé",
      "wot_mode": "WOT Mode",
      "337_hp": "≈ 33.7 HP",
      "got_it": "Compris ! ✓",
      "idle_pid": "IDLE PID",
      "timeslip": "TIMESLIP",
      "psi": "-- PSI",
      "setup": "Configuration",
      "player": "Player",
      "click": "Click",
      "back": "← Retour",
      "25s": "-2.5s",
      "for": "° for",
      "speed": "VITESSE",
      "accel": "ACCÉL",
      "slip": "GLISSE !",
      "time": "TEMPS",
      "gear": "VIT",
      "mods": "Mods",
      "tdc": "PMH",
      "mph": "MPH",
      "mod_intake": "Admission",
      "mod_intake_manifold": "Collecteur d'Admission",
      "mod_exhaust_manifold": "Collecteur d'Échappement",
      "mod_exhaust": "Échappement",
      "mod_port_and_polish": "Portage et Polissage",
      "mod_turbocharger": "Turbocompresseur",
      "mod_supercharger": "Compresseur",
      "mod_camshaft": "Arbre à Cames",
      "mod_pistons": "Pistons",
      "mod_rods": "Bielles",
      "mod_clutch": "Embrayage",
      "mod_intercooler": "Intercooler",
      "mod_fuel_pump": "Pompe à Carburant",
      "mod_fuel_injector": "Injecteur de Carburant",
      "stock_none": "D'origine / Aucun",
      "dry_shot_system": "Système Dry Shot",
      "wet_shot_system": "Système Wet Shot",
      "buy_nitrous_kit": "Acheter Kit Nitro !",
      "mod_settings": "Réglages Mods",
      "wastegate_spring_psi": "Ressort Wastegate (psi)",
      "wastegate_spring_kpa": "Ressort Wastegate (kPa)",
      "map_axes_scale_help": "Les axes MAP s'adaptent à 2× la pression du ressort.",
      "closed_loop_boost": "Boost en Boucle Fermée",
      "pulley_ratio": "Rapport de Poulie (SC/Moteur)",
      "bypass_threshold": "Seuil de Bypass (%)",
      "max_sc_rpm": "RPM Max SC :",
      "twin_turbo_setup": "Configuration Twin Turbo",
      "twin_turbo_help": "(×1.9 débit d'air, ~½× vitesse de spool)",
      "custom_transmission": "Transmission Personnalisée",
      "applied": "Appliqué !",
      "stop_engine": "ARRÊTER MOTEUR",
      "flooded": "NOYÉ",
      "no_start_trigger": "PAS DE DÉMARRAGE : ANGLE DÉCLENCHEUR",
      "no_start_lean": "PAS DE DÉMARRAGE : MÉLANGE PAUVRE",
      "stalled": "CALÉ",
      "stalled_rpm": "CALÉ : Le régime est tombé sous la vitesse de démarrage.",
      "stalled_battery": "CALÉ : Tension batterie critiquement basse (8 V).",
      "submitting": "Envoi...",
      "submitted": "Envoyé !",
      "error_retry": "Erreur (Réessayer)"
    }
  }
};